<template>

  <div class="hit-list-group" >

    <div class="hit-progress">
      <div class="hit-progress-bar" role="progressbar" v-bind:style="{width: ( loaded.length / getBoards.length  * 100 )+'%'}">
        <span class="sr-only">{{ Math.round((loaded.length / getBoards.length  * 100)) }}%</span>
      </div>
    </div>

    <transition-group name="fade">
    <div v-for="(board, index) in getBoards" class="hit-list-group-item" v-if="typeof loaded[index] != 'undefined'" v-bind:key="loaded[index]">

      <div>
        <span v-if="typeof loaded[index] == 'undefined'"><hit_icon class="hit-text-warning" :id='"clock"' /></span>
        <span v-else><hit_icon class="hit-text-success" :id='"ok"' /></span>

        &nbsp;<b>{{ board.votes.length }}</b> x <b>{{ board.name }}</b></div>

    </div>
    </transition-group>

  </div>

</template>

<script>

export default{
  props: {data: Object},

  data () {
    return {
      loaded: []
    }
  },

  computed: {

    getBoards () {
      this.data.boards.forEach(function (val, key) {
        this.setData(key)
      }.bind(this))

      return this.data.boards
    }
  },

  methods: {

    get_loaded (board) {
      return this.loaded.indexOf(board.ID)
    },
    async setData (ID) {
      await setTimeout(function () {

        var board = JSON.parse(JSON.stringify(this.data.boards[ID]));
        board.votes = JSON.stringify(board.votes);
        board.votes_delete = JSON.stringify(board.votes_delete);
        board.votes_validate = JSON.stringify(board.votes_validate);

        this.$hit_post({url: 'hitclick/hitorshit/import',
          data: {user: this.$store.getters.user.md5_id, data: board },
          callback: function (ret) {
            this.loaded.push(ID)

            if (Object.keys(this.loaded).length == Object.keys(this.data.boards).length) { this.reloadData() }
          }.bind(this)})
      }.bind(this), 2000 * ID)
    },

    reloadData () {
      this.$store.dispatch('get_user_boards')
 		  this.$store.dispatch('get_all_votes')
    }
  }
}

</script>
